import { CommonModule } from '@angular/common'

import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { PrimengModule } from '../primeng/primeng.module'

import { NgModule } from '@angular/core'
import { FullCalendarModule } from '@fullcalendar/angular'
import { QRCodeModule } from 'angularx-qrcode'
import { PdfViewerModule } from 'ng2-pdf-viewer'
import { ImageCropperModule } from 'ngx-image-cropper'
import { MarkdownModule } from 'ngx-markdown'
import { IConfig, NgxMaskModule } from 'ngx-mask'
import { ReteModule } from 'rete-angular-plugin/14'
import { DomainModule } from 'src/app/domain/domain.module'
import { HighchartsModule } from '../highcharts/highcharts.module'
import { AccountingCostSelectorComponent } from './accounting-cost-selector/accounting-cost-selector.component'
import { AccountingRuleSelectorComponent } from './accounting-rule-selector/accounting-rule-selector.component'
import { AccountsPlanSelectorComponent } from './accounts-plan-selector/accounts-plan-selector.component'
import { AiHistoryActionCardComponent } from './ai-history-action-card/ai-history-action-card.component'
import { AnimatedPencilComponent } from './animated-pencil/animated-pencil.component'
import { ApportionmentSelectorComponent } from './apportionment-selector/apportionment-selector.component'
import { ApprovalSidebarContentComponent } from './approval-sidebar/approval-sidebar-content/approval-sidebar-content.component'
import { ApprovalSidebarComponent } from './approval-sidebar/approval-sidebar.component'
import { AssistantAiCardGroupComponent } from './assistant-ai-card-group/assistant-ai-card-group.component'
import { AvatarComponent } from './avatar/avatar.component'
import { BlockedLayerComponent } from './blocked-layer/blocked-layer.component'
import { BoletoDetailsComponent } from './boleto-details/boleto-details.component'
import { BrandingComponent } from './branding/branding.component'
import { ButtonComponent } from './button/button.component'
import { CalendarComponent } from './calendar/calendar.component'
import { CardListCellDirective } from './card-list/card-list-cell.directive'
import { CardListComponent } from './card-list/card-list.component'
import { CarouselComponent } from './carousel/carousel.component'
import { ChartComponent } from './chart/chart.component'
import { CheckboxComponent } from './checkbox/checkbox.component'
import { ChipPercentualVariationComponent } from './chip-percentual-variation/chip-percentual-variation.component'
import { ChipComponent } from './chip/chip.component'
import { ColorPickerComponent } from './color-picker/color-picker.component'
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component'
import { ContextMenuComponent } from './context-menu/context-menu.component'
import { CrmAnswerDialogComponent } from './crm-answer-dialog/crm-answer-dialog.component'
import { DashCardComponent } from './dash-card/dash-card.component'
import { DataViewComponent } from './data-view/data-view.component'
import { DialogComponent } from './dialog/dialog.component'
import { DropdownComponent } from './dropdown/dropdown.component'
import { EditableTableComponent } from './editable-table/editable-table.component'
import { EditorComponent } from './editor/editor.component'
import { ExplanationComponent } from './explanation/explanation.component'
import { ExternalScreenComponent } from './external-screen/external-screen.component'
import { FullScreenComponent } from './full-screen/full-screen.component'
import { GalleriaComponent } from './galleria/galleria.component'
import { HeaderComponent } from './header/header.component'
import { HealthGaugeComponent } from './health-gauge/health-gauge.component'
import { HealthStatusWidgetComponent } from './health-status-widget/health-status-widget.component'
import { IconComponent } from './icon/icon.component'
import { ImageCropperComponent } from './image-cropper/image-cropper.component'
import { ImageComponent } from './image/image.component'
import { InfiniteScrollListComponent } from './infinite-scroll-list/infinite-scroll-list.component'
import { InfoCardComponent } from './info-card/info-card.component'
import { InputChipsComponent } from './input-chips/input-chips.component'
import { InputMaskComponent } from './input-mask/input-mask.component'
import { InputMentionComponent } from './input-mention/input-mention.component'
import { InputNumberComponent } from './input-number/input-number.component'
import { InputPasswordValidatedComponent } from './input-password-validated/input-password-validated.component'
import { InputPasswordComponent } from './input-password/input-password.component'
import { InputTextComponent } from './input-text/input-text.component'
import { IntegratedOverlayScreenComponent } from './integrated-overlay-screen/integrated-overlay-screen.component'
import { ItemSelectorComponent } from './item-selector/item-selector.component'
import { KanbanComponent } from './kanban/kanban.component'
import { LoadingLayerComponent } from './loading-layer/loading-layer.component'
import { MarkdownViewerComponent } from './markdown-viewer/markdown-viewer.component'
import { MessageTapeComponent } from './message-tape/message-tape.component'
import { MultiselectComponent } from './multiselect/multiselect.component'
import { NotificationComponent } from './notification/notification.component'
import { OctaLoaderComponent } from './octa-loader/octa-loader.component'
import { OfflineScreenComponent } from './offline-screen/offline-screen.component'
import { OperationRuleSelectorComponent } from './operation-rule-selector/operation-rule-selector.component'
import { OrderContractInstallmentTableComponent } from './order-contract-installment-table/order-contract-installment-table.component'
import { OrderContractSidebarComponent } from './order-contract-sidebar/order-contract-sidebar.component'
import { OrderFormComponent } from './order-form/order-form.component'
import { OverlayPanelComponent } from './overlay-panel/overlay-panel.component'
import { PageComponent } from './page/page.component'
import { PaginatorComponent } from './paginator/paginator.component'
import { PanelComponent } from './panel/panel.component'
import { ParticipantSelectorComponent } from './participant-selector/participant-selector.component'
import { PaymentInformationSelectorComponent } from './payment-information-selector/payment-information-selector.component'
import { PdfPreviewDialogComponent } from './pdf-preview-dialog/pdf-preview-dialog.component'
import { PicklistComponent } from './picklist/picklist.component'
import { QuotationEditFormComponent } from './quotation-edit-form/quotation-edit-form.component'
import { QuotationSidebarContentComponent } from './quotation-sidebar/quotation-sidebar-content/quotation-sidebar-content.component'
import { QuotationSidebarComponent } from './quotation-sidebar/quotation-sidebar.component'
import { RadioComponent } from './radio/radio.component'
import { RegistrationBranchMatrizNoticeComponent } from './registration-branch-matriz-notice/registration-branch-matriz-notice.component'
import { RegistrationOperationAccountingRuleFormComponent } from './registration-operation-accounting-rule-form/registration-operation-accounting-rule-form.component'
import { RegistrationOperationRuleFormComponent } from './registration-operation-rule-form/registration-operation-rule-form.component'
import { RegistrationParticipantFormComponent } from './registration-participant-form/registration-participant-form.component'
import { RegistrationProductServiceFormComponent } from './registration-product-service-form/registration-product-service-form.component'
import { ReportActionCardComponent } from './report-action-card/report-action-card.component'
import { RmsFormComponent } from './rms-form/rms-form.component'
import { RmsSelectorComponent } from './rms-selector/rms-selector.component'
import { SalesOrderLinkSelectorComponent } from './sales-order-link-selector/sales-order-link-selector.component'
import { ScheduleCalendarComponent } from './schedule-calendar/schedule-calendar.component'
import { ScheduleConfigurationComponent } from './schedule-configuration/schedule-configuration.component'
import { ScheduleSlotPickerComponent } from './schedule-slot-picker/schedule-slot-picker.component'
import { SendForSignatureModalComponent } from './send-for-signature-modal/send-for-signature-modal.component'
import { SidenavLinkComponent } from './sidenav/sidenav-link/sidenav-link.component'
import { SidenavMainButtonComponent } from './sidenav/sidenav-main-button/sidenav-main-button.component'
import { SidenavComponent } from './sidenav/sidenav.component'
import { SignatureEnvelopeSidebarComponent } from './signature-envelope-sidebar/signature-envelope-sidebar.component'
import { SplashScreenComponent } from './splash-screen/splash-screen.component'
import { SqlBuilderComponent } from './sql-builder/sql-builder.component'
import { StepsComponent } from './steps/steps.component'
import { StockAddressingModalComponent } from './stock-addressing-modal/stock-addressing-modal.component'
import { TabChipComponent } from './tab-chip/tab-chip.component'
import { TabViewComponent } from './tab-view/tab-view.component'
import { TablePermissionComponent } from './table-permission/table-permission.component'
import { TableComponent } from './table/table.component'
import { TagSelectorComponent } from './tag-selector/tag-selector.component'
import { TaskDialogComponent } from './task-dialog/task-dialog.component'
import { TaskItemComponent } from './task-dialog/task-item/task-item.component'
import { TextAreaComponent } from './text-area/text-area.component'
import { TieredMenuComponent } from './tiered-menu/tiered-menu.component'
import { TimelineComponent } from './timeline/timeline.component'
import { ToastComponent } from './toast/toast.component'
import { ToggleComponent } from './toggle/toggle.component'
import { ToolbarComponent } from './toolbar/toolbar.component'
import { TooltipComponent } from './tooltip/tooltip.component'
import { TreeTableComponent } from './tree-table/tree-table.component'
import { TreeComponent } from './tree/tree.component'
import { UploadComponent } from './upload/upload.component'
import { UserPreferencesModalComponent } from './user-preferences-modal/user-preferences-modal.component'
import { VersionUpdateScreenComponent } from './version-update-screen/version-update-screen.component'
import { ApprovedNodeComponent } from './workflow-board/approved-node/approved-node.component'
import { ApproverNodeComponent } from './workflow-board/approver-node/approver-node.component'
import { ConditionNodeComponent } from './workflow-board/condition-node/condition-node.component'
import { CustomConnectionComponent } from './workflow-board/custom-connection/custom-connection.component'
import { CustomSocketComponent } from './workflow-board/custom-socket/socket.component'
import { PlusNodeComponent } from './workflow-board/plus-node/plus-node.component'
import { RefusedNodeComponent } from './workflow-board/refused-node/refused-node.component'
import { StartNodeComponent } from './workflow-board/start-node/start-node.component'
import { StepNodeComponent } from './workflow-board/step-node/step-node.component'
import { WorkflowBoardComponent } from './workflow-board/workflow-board.component'

export const options: Partial<null | IConfig> | (() => Partial<IConfig>) = null

@NgModule({
  declarations: [
    SidenavComponent,
    InputTextComponent,
    ButtonComponent,
    BrandingComponent,
    ToastComponent,
    HeaderComponent,
    IconComponent,
    DropdownComponent,
    AvatarComponent,
    TieredMenuComponent,
    OverlayPanelComponent,
    TooltipComponent,
    PageComponent,
    TableComponent,
    ToolbarComponent,
    CheckboxComponent,
    ConfirmDialogComponent,
    DialogComponent,
    DialogComponent,
    CalendarComponent,
    SplashScreenComponent,
    ChipComponent,
    EditorComponent,
    UploadComponent,
    RadioComponent,
    TextAreaComponent,
    InputPasswordComponent,
    InputNumberComponent,
    InputMaskComponent,
    LoadingLayerComponent,
    ToggleComponent,
    MultiselectComponent,
    ApprovalSidebarComponent,
    ApprovalSidebarContentComponent,
    CrmAnswerDialogComponent,
    PanelComponent,
    PdfPreviewDialogComponent,
    SidenavMainButtonComponent,
    SidenavLinkComponent,
    ParticipantSelectorComponent,
    DataViewComponent,
    CardListComponent,
    CardListCellDirective,
    BlockedLayerComponent,
    PaymentInformationSelectorComponent,
    InfoCardComponent,
    TabViewComponent,
    ApportionmentSelectorComponent,
    ItemSelectorComponent,
    ChartComponent,
    DashCardComponent,
    PaginatorComponent,
    ChipPercentualVariationComponent,
    AccountsPlanSelectorComponent,
    MessageTapeComponent,
    EditableTableComponent,
    NotificationComponent,
    OctaLoaderComponent,
    OfflineScreenComponent,
    VersionUpdateScreenComponent,
    ReportActionCardComponent,
    FullScreenComponent,
    TabChipComponent,
    PicklistComponent,
    TreeComponent,
    ImageComponent,
    OrderFormComponent,
    QuotationEditFormComponent,
    QuotationSidebarComponent,
    QuotationSidebarContentComponent,
    SendForSignatureModalComponent,
    SignatureEnvelopeSidebarComponent,
    TreeTableComponent,
    ImageComponent,
    InputChipsComponent,
    KanbanComponent,
    StockAddressingModalComponent,
    OrderContractInstallmentTableComponent,
    ExplanationComponent,
    AssistantAiCardGroupComponent,
    AiHistoryActionCardComponent,
    InfiniteScrollListComponent,
    ContextMenuComponent,
    TagSelectorComponent,
    ColorPickerComponent,
    StepsComponent,
    InputPasswordValidatedComponent,
    TablePermissionComponent,
    ImageCropperComponent,
    AccountingCostSelectorComponent,
    WorkflowBoardComponent,
    StartNodeComponent,
    CustomSocketComponent,
    CustomConnectionComponent,
    StepNodeComponent,
    ApprovedNodeComponent,
    RefusedNodeComponent,
    ApproverNodeComponent,
    ConditionNodeComponent,
    PlusNodeComponent,
    SqlBuilderComponent,
    RegistrationOperationAccountingRuleFormComponent,
    RegistrationOperationRuleFormComponent,
    RegistrationBranchMatrizNoticeComponent,
    RegistrationParticipantFormComponent,
    RegistrationProductServiceFormComponent,
    RmsFormComponent,
    RmsSelectorComponent,
    SalesOrderLinkSelectorComponent,
    OrderContractSidebarComponent,
    OperationRuleSelectorComponent,
    AccountingRuleSelectorComponent,
    InputMentionComponent,
    TaskDialogComponent,
    TaskItemComponent,
    UserPreferencesModalComponent,
    GalleriaComponent,
    CarouselComponent,
    ExternalScreenComponent,
    HealthGaugeComponent,
    HealthStatusWidgetComponent,
    ScheduleCalendarComponent,
    ScheduleConfigurationComponent,
    ScheduleSlotPickerComponent,
    IntegratedOverlayScreenComponent,
    MarkdownViewerComponent,
    AnimatedPencilComponent,
    BoletoDetailsComponent,
    TimelineComponent
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, PrimengModule, HighchartsModule, NgxMaskModule.forRoot(), DomainModule, ImageCropperModule, ReteModule, QRCodeModule, FullCalendarModule, PdfViewerModule, MarkdownModule.forRoot()],
  exports: [
    SidenavComponent,
    InputTextComponent,
    ButtonComponent,
    BrandingComponent,
    ToastComponent,
    HeaderComponent,
    IconComponent,
    DropdownComponent,
    AvatarComponent,
    TieredMenuComponent,
    TooltipComponent,
    PageComponent,
    TableComponent,
    ToolbarComponent,
    CheckboxComponent,
    ConfirmDialogComponent,
    DialogComponent,
    CalendarComponent,
    SplashScreenComponent,
    ChipComponent,
    EditorComponent,
    UploadComponent,
    RadioComponent,
    TextAreaComponent,
    InputPasswordComponent,
    InputNumberComponent,
    InputMaskComponent,
    LoadingLayerComponent,
    ToggleComponent,
    MultiselectComponent,
    ApprovalSidebarComponent,
    CrmAnswerDialogComponent,
    PanelComponent,
    ParticipantSelectorComponent,
    CardListComponent,
    CardListCellDirective,
    BlockedLayerComponent,
    PaymentInformationSelectorComponent,
    InfoCardComponent,
    TabViewComponent,
    ApportionmentSelectorComponent,
    ItemSelectorComponent,
    ChartComponent,
    DashCardComponent,
    PaginatorComponent,
    ChipPercentualVariationComponent,
    AccountsPlanSelectorComponent,
    MessageTapeComponent,
    EditableTableComponent,
    OctaLoaderComponent,
    OfflineScreenComponent,
    VersionUpdateScreenComponent,
    ReportActionCardComponent,
    FullScreenComponent,
    TabChipComponent,
    PicklistComponent,
    TreeComponent,
    ImageComponent,
    OrderFormComponent,
    QuotationEditFormComponent,
    QuotationSidebarComponent,
    SendForSignatureModalComponent,
    SignatureEnvelopeSidebarComponent,
    TreeTableComponent,
    ImageComponent,
    InputChipsComponent,
    KanbanComponent,
    StockAddressingModalComponent,
    OrderContractInstallmentTableComponent,
    ExplanationComponent,
    AssistantAiCardGroupComponent,
    AiHistoryActionCardComponent,
    InfiniteScrollListComponent,
    ContextMenuComponent,
    TagSelectorComponent,
    ColorPickerComponent,
    StepsComponent,
    InputPasswordValidatedComponent,
    TablePermissionComponent,
    ImageCropperComponent,
    AccountingCostSelectorComponent,
    WorkflowBoardComponent,
    SqlBuilderComponent,
    RegistrationOperationAccountingRuleFormComponent,
    RegistrationOperationRuleFormComponent,
    RegistrationBranchMatrizNoticeComponent,
    RegistrationParticipantFormComponent,
    RegistrationProductServiceFormComponent,
    RmsFormComponent,
    OrderContractSidebarComponent,
    OperationRuleSelectorComponent,
    AccountingRuleSelectorComponent,
    QRCodeModule,
    OverlayPanelComponent,
    PdfPreviewDialogComponent,
    InputMentionComponent,
    TaskDialogComponent,
    TaskItemComponent,
    UserPreferencesModalComponent,
    GalleriaComponent,
    CarouselComponent,
    ExternalScreenComponent,
    HealthGaugeComponent,
    HealthStatusWidgetComponent,
    ScheduleCalendarComponent,
    ScheduleConfigurationComponent,
    ScheduleSlotPickerComponent,
    IntegratedOverlayScreenComponent,
    RmsSelectorComponent,
    SalesOrderLinkSelectorComponent,
    MarkdownViewerComponent,
    BoletoDetailsComponent,
    TimelineComponent
  ]
})
export class ComponentsModule {}
